import React from 'react';
import ColorPicker from 'core/colorPicker';
import { FormField } from 'ui/formField';
import { createObjectWithKey } from 'utils/helpers';
import { ColorPickerContainer, ColorLabel } from './customWidgetSettings.styled';

// type Props = {
//   /** Callback function when value is changed. */
//   onChange: () => void,
//   /** Value of the trendDirection */
//   value: string,
// };

export default class TrendColors extends React.Component {
  static defaultProps = {
    value: {
      up: '#00d034',
      down: '#eb144c',
    },
  };

  /**
   * handleChange
   * Callback function when trend color values change.
   * @param { Object } e: The change event.
   * @param { Object } colorProps: The props of the color picker including the updated value.
   * @returns { void }
   */
  handleChange = (e, { name, value }) => {
    const { onChange, value: oldValue } = this.props;
    const changedValue = createObjectWithKey(name, value);
    onChange(e, { value: { ...oldValue, ...changedValue } });
  };

  render() {
    const { value } = this.props;
    const { up, down } = value;

    return (
      <div>
        <FormField>
          <ColorPickerContainer>
            <ColorPicker onChange={this.handleChange} name="up" value={up} />
            <ColorLabel>Trend Up</ColorLabel>
          </ColorPickerContainer>
        </FormField>
        <FormField>
          <ColorPickerContainer>
            <ColorPicker onChange={this.handleChange} name="down" value={down} />
            <ColorLabel>Trend Down</ColorLabel>
          </ColorPickerContainer>
        </FormField>
      </div>
    );
  }
}
